import React from 'react'
import { CompanyProfileSupplierFormStyle } from './styled'
import {
  Button,
  Image,
  Input,
  Section,
  SelectBox,
  InputTextarea,
  InputUpload,
  Checkbox,
  Table,
  Modal,
  DatePickerInput,
  AttachedFile,
  Loaders,
} from '../../components'
import {
  ROUTE_PATH,
  yup as Yup,
  STRING,
  toastActive,
  toastFail,
  trimmedString,
  dateMonDayYearTime,
  localStorageService,
} from '../../helpers'
import { ICONS } from '../../themes'
import {
  mySupplierCompanyController,
  currencyController,
  countryController,
} from '../../apiService/index'
import { Formik, Form } from 'formik'
import { strWithCommas, numberRemoveCommas } from '../../helpers/number/commas'
import FileDownload from 'js-file-download'

export class CompanyProfileSupplierFormContainer extends React.Component {
  _isMounted = false
  constructor(props) {
    super(props)

    this.state = {
      supplierNation: 'domestic',
      optionsCountry: [],
      isEditPageState: true,
      templateValidText: STRING.INVALID,
      optionsService: [
        {
          value: 'Laboratory Chemicals and Equipments',
          label: 'Laboratory Chemicals and Equipments',
        },
        {
          value: 'Other - Laboratory Chemicals & Equipments',
          label: 'Other - Laboratory Chemicals & Equipments',
        },
      ],
      modals: [
        { name: 'edit', isOpen: false },
        { name: 'delete', isOpen: false },
        { name: 'add', isOpen: false },
      ],
      editState: true,
      cancelState: false,
      saveState: false,
      serviceState: false,
      supplierCompany: [],
      businessCategories: [],
      serviceCategory: [],
      formInit: {
        buyer_supplier_company_id: '',
        supplier_company_id: '',
        tax_id: '',
        company_name: '',
        branch: '',
        year_established: '',
        regis_capital: 0.0,
        regis_address: '',
        regis_country: {},
        contact_address: '',
        contact_country: {},
        phone: '',
        fax: '',
        email: '',
        website: '',
        currency: { id: 0, name: '' },
        my_supplier_company_service_category: [
          {
            id: 0,
            supplier_company_id: 0,
            sub_category_id: 0,
            category_id: 0,
            sub_category_name: '',
            category_name: '',
          },
        ],
        business_type: [],
      },
      infoCategory: [],
      currencyOption: [],
      optionBusinessType: [],
      businessSubCategories: [],
      selectedFile: [],
      attachmentFile: [],
      indexCategory: 0,
      joinMainSupplier: false,
      supplierCategory: [],
      isPass: true,
      onlineTemplates: [],
      userId: localStorageService.getBuyerId(),
      loadingDownloadFile: [],
    }

    this._isMounted = true
  }

  componentDidMount = () => {
    if (this._isMounted) {
      this.setState({ isLoading: true })
      this.getMySupplierCompany()
      this.fetchBusinessType()
      this.fetchBusinessCategories()
      this.getCurrency()
      this.getCountry()
    }
  }

  fetchBusinessType = async () => {
    try {
      const res = await mySupplierCompanyController().getBusinessType()
      if (res) {
        let businessType = []
        res.map(e => {
          let options = {
            id: e.id,
            value: e.name,
            checked: false,
          }
          businessType.push(options)
        })
        this.setState({
          optionBusinessType: businessType,
        })
      }
    } catch (error) {
      throw ('optionBusinessType fail', error)
    }
  }

  getMySupplierCompany = async () => {
    try {
      this.setState({ isLoading: true })
      const res = await mySupplierCompanyController().getMySupplierCompany()
      console.log(res)
      if (res) {
        let supplierCompany = res
        let supplierCategory = this.groupCategory(
          supplierCompany.my_supplier_company_service_category
        )

        const supplierNation =
          res.contact_country.name === 'Thailand' ? 'domestic' : 'international'
        await this.getCountry(supplierNation)
        if (res.business_type.length > 0) {
          res.business_type.map(e => {
            if (e.name !== '' && this.state.optionBusinessType.length > 0) {
              var index = this.state.optionBusinessType.findIndex(
                j => j.id === e.id
              )
              this.state.optionBusinessType[index].checked = true
            }
          })
        }
        this.setState({
          formInit: {
            buyer_supplier_company_id: res.buyer_supplier_company_id,
            supplier_company_id: res.supplier_company_id,
            tax_id: res.tax_id,
            company_name: res.company_name,
            business_type: res.business_type,
            branch: res.branch,
            year_established: res.year_established,
            // regis_capital: res.regis_capital
            //   ? this.numberWithCommas(res.regis_capital)
            //   : 0,
            regis_capital: res.regis_capital,
            regis_address: res.regis_address,
            regis_country: {
              value: res.regis_country.id,
              label: res.regis_country.name,
            },
            contact_country: {
              value: res.contact_country.id,
              label: res.contact_country.name,
            },
            contact_address: res.contact_address,
            phone: res.phone,
            fax: res.fax,
            email: res.email,
            website: res.website,
            currency: res.currency,
            my_supplier_company_service_category:
              res.my_supplier_company_service_category,
            file_supplier_discovery: res.file_supplier_discovery,
            company_type: res.company_type,
          },
          isLoading: false,
          supplierCompany,
          supplierCategory,
          supplierNation,
        })
        this.getOnlineTemplate(supplierCompany.buyer_supplier_company_id)
      }
    } catch (error) {
      throw error
    }
  }

  fetchbusinessSubCategories = async id => {
    try {
      const res = await mySupplierCompanyController().getBusinessSubCategories(
        id
      )
      if (res) {
        let subCategories = []
        res.map(e => {
          let options = {
            id: e.id,
            value: e.name,
            checked: false,
          }
          subCategories.push(options)
        })
        this.setState({
          businessSubCategories: subCategories,
        })
      }
    } catch (error) {
      throw ('BusinessSubCategories fail', error)
    }
  }

  fetchBusinessCategories = async () => {
    try {
      const res = await mySupplierCompanyController().getBusinessCategories()
      if (res) {
        let categories = []
        res.map(e => {
          let options = {
            id: e.id,
            value: e.name,
            label: e.name,
          }
          categories.push(options)
        })
        this.setState({
          businessCategories: categories,
        })
      }
    } catch (error) {
      throw ('fetchBusinessCategories fail', error)
    }
  }

  fetchbusinessSubCategoriesEdit = async event => {
    try {
      const res = await mySupplierCompanyController().getBusinessSubCategories(
        event.category_id
      )
      if (res) {
        let subCategories = []
        let options = {}
        res.map(e => {
          if (event.sub_category.find(j => j.sub_category_name === e.name)) {
            options = {
              id: e.id,
              value: e.name,
              checked: true,
            }
          } else {
            options = {
              id: e.id,
              value: e.name,
              checked: false,
            }
          }
          subCategories.push(options)
        })
        this.setState({
          businessSubCategories: subCategories,
        })
      }
    } catch (error) {
      throw ('BusinessSubCategories fail', error)
    }
  }

  groupBy = (xs, key) => {
    return xs.reduce(function (rv, x) {
      ;(rv[x[key]] = rv[x[key]] || []).push(x)
      return rv
    }, {})
  }

  groupCategory = obj => {
    let serviceCategory = []
    let res = this.groupBy(obj, 'category_id')
    for (var key in res) {
      // if (res.hasOwnProperty(key)) console.log(res[key])
      let sub_category = []
      for (var i = 0; i < res[key].length; i++) {
        sub_category.push({
          id: res[key][i].sub_category_id,
          sub_category_name: res[key][i].sub_category_name,
        })
      }
      let category = {
        category_id: key,
        category_name: res[key][0].category_name,
        sub_category: sub_category,
      }
      serviceCategory.push(category)
    }
    return serviceCategory
  }

  onClickAdd = () => {
    const infoCategory = []
    document.body.classList.add('modal-open')
    this.setState({ infoCategory }, this.toggleModal('add'))
  }

  onDeleteCategory = (e, i) => {
    const indexCategory = i
    const infoCategory = e
    this.setState({ indexCategory, infoCategory }, this.toggleModal('delete'))
  }

  onChangeBusinessType = (formikSetvalue, e, i) => {
    let { optionBusinessType } = this.state
    optionBusinessType[i].checked = !optionBusinessType[i].checked
    this.setState({ optionBusinessType })
    let business_type = []
    optionBusinessType.map(e => {
      if (e.checked === true) {
        business_type.push({ id: e.id, name: e.value })
      }
    })
    formikSetvalue('business_type', business_type)
  }

  toggleModal = evt => {
    this.setState(prevState => ({
      ...prevState,
      modals: prevState.modals.map(modal => ({
        ...modal,
        isOpen: modal.name === evt ? !modal.isOpen : false,
      })),
    }))
  }

  onClickConfirmDelete = () => {
    let { supplierCategory, indexCategory, supplierCompany } = this.state
    supplierCategory.splice(indexCategory, 1)

    const my_supplier_company_service_category =
      supplierCompany.my_supplier_company_service_category
    my_supplier_company_service_category.splice(indexCategory, 1)

    this.toggleModal('delete')
  }

  onClickConfirm = () => {
    let {
      supplierCategory,
      infoCategory,
      businessSubCategories,
      supplierCompany,
    } = this.state
    let isPass = true
    const my_supplier_company_service_category =
      supplierCompany.my_supplier_company_service_category
    if (supplierCategory.length > 0) {
      supplierCategory.map((e, i) => {
        if (e.category_id === infoCategory.category_option.id) {
          toastFail('Business Group is duplicate')
          return (isPass = false)
        }
      })
    }
    if (isPass) {
      let newCategory = {
        sub_category: [],
      }
      newCategory.category_id = infoCategory.category_option.id
      newCategory.category_name = infoCategory.category_option.value
      businessSubCategories.map(e => {
        const newSubCategory = {}
        if (e.checked === true) {
          newSubCategory.category_id = infoCategory.category_option.id
          newSubCategory.id = e.id
          newSubCategory.sub_category_name = e.value
          newCategory.sub_category.push(newSubCategory)
        }
      })
      supplierCategory.push(newCategory)

      supplierCategory.map(e => {
        e.sub_category.map(j => {
          my_supplier_company_service_category.push({
            sub_category_id: j.id,
            sub_category_name: j.sub_category_name,
          })
        })
      })

      document.body.classList.remove('modal-open')
      this.toggleModal('add')
    }
  }

  onEditCategory = async (e, i) => {
    const infoCategory = e
    const indexCategory = i
    this.setState(
      { infoCategory, indexCategory },
      this.toggleModal('edit'),
      await this.fetchbusinessSubCategoriesEdit(e)
    )
  }

  onClickConfirmEdit = () => {
    let {
      supplierCategory,
      indexCategory,
      infoCategory,
      businessSubCategories,
    } = this.state

    let newCategory = {
      sub_category: [],
    }
    newCategory.category_id = infoCategory.category_id
    newCategory.category_name = infoCategory.category_name
    businessSubCategories.map(e => {
      const newSubCategory = {}
      if (e.checked === true) {
        newSubCategory.category_id = infoCategory.category_id
        newSubCategory.id = e.id
        newSubCategory.sub_category_name = e.value
        newCategory.sub_category.push(newSubCategory)
      }
    })

    supplierCategory[indexCategory] = newCategory
    this.setState({ supplierCategory }, this.toggleModal('edit'))
  }

  onChangeSubCategory = (e, i) => {
    let { businessSubCategories, supplierCompany } = this.state
    businessSubCategories[i].checked = !businessSubCategories[i].checked
    this.setState({ businessSubCategories })

    const my_supplier_company_service_category =
      supplierCompany.my_supplier_company_service_category
    businessSubCategories.map(e => {
      if (e.checked === true) {
        my_supplier_company_service_category.push({
          sub_category_id: e.id,
          sub_category_name: e.value,
        })
      }
    })
  }

  onClickClose = () => {
    this.toggleModal()
    document.body.classList.remove('modal-open')
  }

  onJoinMainSupplier = () => {
    const joinMainSupplier = !this.state.joinMainSupplier
    this.setState({
      joinMainSupplier,
    })
  }
  getCountry = async (supplierNation = ' ') => {
    try {
      this.setState({ isLoading: true })
      const res = await countryController().getListCountry()
      if (res) {
        const countryList = res.map(e => {
          return {
            value: e.id,
            label: e.name,
          }
        })
        if (supplierNation === 'international') {
          const indexCountry = countryList.findIndex(e => {
            return e.label === 'Thailand'
          })
          countryList.splice(indexCountry, 1)
        }
        this.setState({ optionsCountry: countryList })
        this.setState({ isLoading: false })
      }
    } catch (error) {
      throw error
    }
  }

  getOnlineTemplate = async id => {
    try {
      const res = await mySupplierCompanyController().getOnlineTemplate(id)
      // console.log(res)
      if (res && res.data.status === 'success') {
        this.setState({ onlineTemplates: res.data.result })
      }
    } catch (error) {
      console.log(error)
    }
  }

  onChangeBusinessGroup = async e => {
    let { infoCategory } = this.state
    infoCategory.category_option = e
    this.setState({ infoCategory }, await this.fetchbusinessSubCategories(e.id))
  }

  editForm = () => {
    this.setState({
      editState: false,
      cancelState: true,
      saveState: true,
      isEditPageState: false,
      serviceState: true,
    })
  }

  cancelForm = props => {
    this.getMySupplierCompany()
    props.resetForm()
    this.setState({
      editState: true,
      cancelState: false,
      saveState: false,
      isEditPageState: true,
      serviceState: false,
      selectedFile: [],
      attachmentFile: [],
    })
  }

  saveForm = () => {
    this.setState({
      editState: true,
      cancelState: false,
      saveState: false,
      isEditPageState: true,
      serviceState: false,
      selectedFile: [],
      attachmentFile: [],
    })
  }

  getCurrency = async () => {
    try {
      this.setState({ isLoading: true })
      const res = await currencyController().getCurrency()
      let data = res.map(val => {
        return { id: val.id, label: val.name }
      })
      this.setState({ currencyOption: data })
    } catch (error) {
      throw error
    }
  }

  downloadAttachment = (params, i) => {
    const { loadingDownloadFile } = this.state
    let loading = loadingDownloadFile
    loading.push({ id_file: i })
    console.log('set loading', loading)
    this.setState({
      loadingDownloadFile: loading,
    })
    const funcDownloadFile = async () => {
      try {
        const { name, id } = params
        const dataFile = await mySupplierCompanyController().downloadAttachment(
          id
        )
        const { data } = dataFile
        FileDownload(data, name)
        this.deleteLoadingDownloadFile(i)
      } catch (error) {
        console.log(error)
      }
    }
    if (params.id) {
      funcDownloadFile()
    } else {
      FileDownload(params.files, params.name)
      this.deleteLoadingDownloadFile(i)
    }
  }

  deleteLoadingDownloadFile = i => {
    const { loadingDownloadFile } = this.state
    if (loadingDownloadFile.length > 0) {
      loadingDownloadFile.map(e => console.log('e loading', e.id_file))
      let index = loadingDownloadFile.findIndex(x => x.id_file === i)
      if (index > -1) {
        loadingDownloadFile.splice(index, 1)
        this.setState({
          loadingDownloadFile: loadingDownloadFile,
        })
      }
    }
  }

  onRemoveFile = (e, files) => {
    console.log(e)
    console.log(files)
    if (files.length > 0) {
      files.map(f => {
        if (e.supplier_company_id === f.supplier_company_id) {
          f.is_deleted = true
        }
        this.setState({
          attachmentFile: files,
        })
      })
      this.forceUpdate()
    }
  }

  numberWithCommas = x => x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')

  checkPositiveInt = () => {
    return `^[0-9]+(\.[0-9]{1,2})?$`
  }

  validateMySupplierCompanySchema = () => {
    const schema = Yup.object().shape({
      regis_capital: Yup.string()
        .transform(regisCapitalValue => trimmedString(regisCapitalValue))
        .required(STRING.INVALID),
      regis_address: Yup.string()
        .transform(regisAddressValue => trimmedString(regisAddressValue))
        .required(STRING.INVALID),
      phone: Yup.string()
        .required(STRING.INVALID)
        .transform(contactAddressValue => trimmedString(contactAddressValue)),
      email: Yup.string()
        .transform(emailValue => trimmedString(emailValue))
        .required(STRING.INVALID)
        .email(STRING.EMAIL_INVALID),
      contact_address: Yup.string()
        .transform(contactAddressValue => trimmedString(contactAddressValue))
        .required(STRING.INVALID),
      business_type: Yup.array()
        .of(
          Yup.object().shape({
            is_active: Yup.boolean().oneOf([true]),
          })
        )
        .required('Must choose at least one option.'),
      my_supplier_company_service_category: Yup.array().required(
        STRING.INVALID
      ),
    })

    return schema
  }

  validateCheckbox = () => {
    const { businessSubCategories } = this.state
    let notCheck = true
    businessSubCategories.map(e => {
      if (e.checked === true) {
        return (notCheck = false)
      }
    })

    return notCheck
  }

  setInputArrayUploadFile = file => {
    const { selectedFile } = this.state
    selectedFile.push(file)
    this.setState({ selectedFile })
  }

  saveMySupplierCompany = async values => {
    const { optionBusinessType, supplierCategory } = this.state
    try {
      if (values !== '') {
        const business_type = optionBusinessType.map(e => {
          if (e.checked === true) {
            return { id: e.id, name: e.value }
          }
        })
        let service_category = []
        supplierCategory.map(e => {
          e.sub_category.map(j => {
            service_category.push({
              sub_category_id: j.id,
              sub_category_name: j.sub_category_name,
            })
          })
        })

        const params = {
          buyer_supplier_company_id: values.buyer_supplier_company_id,
          supplier_company_id: values.supplier_company_id,
          tax_id: values.tax_id,
          company_name: values.company_name,
          branch: values.branch,
          year_established: values.year_established,
          regis_capital: numberRemoveCommas(values.regis_capital),
          currency: values.currency,
          regis_address: values.regis_address,
          regis_country: parseInt(values.regis_country.value, 10),
          contact_country: parseInt(values.contact_country.value, 10),
          contact_address: values.contact_address,
          phone: values.phone,
          fax: values.fax,
          email: values.email,
          website: values.website,
          file_supplier_discovery: values.file_supplier_discovery,
          business_type: business_type,
          service_category: service_category,
        }

        const req = {
          my_supplier_company: JSON.stringify(params),
          files: this.state.selectedFile,
        }

        const res = await mySupplierCompanyController().updateSupplierSupplier(
          req
        )

        if (res) {
          if (res.status === 'UpdateSuccess') {
            toastActive(res.message)
            this.setState(
              {
                isEditPageState: true,
                cancelState: false,
                saveState: false,
                editState: true,
                serviceState: false,
                selectedFile: [],
                attachmentFile: [],
              }
              // await this.fetchbusinessSubCategoriesEdit(?????)
              // ไม่ได้ยิง get อีกรอบ เพราะ  fetchbusinessSubCategoriesEdit ไม่ได้ รับแค่ id และไม่รู้ว่าต้องรับอะไรบ้าง ขอมักง่าย reload ให้เชอรรี่ไป รีวิว
              //wait refactor
              // window.location.reload(false)
            )
            this.getMySupplierCompany()
          } else {
            toastFail(res.message)
          }
        }
      }
    } catch (error) {
      throw ('update suppiler fail', error)
    }
  }

  onSelectCountry = (event = {}, feild = '') => {
    this.setState(prev => {
      return { formInit: { ...prev.formInit, [feild]: event } }
    })
  }

  renderOnlineComprehensive() {
    const { onlineTemplates, userId } = this.state
    // console.log(onlineTemplates)
    return (
      <div className="form-control-wrapper">
        {onlineTemplates.map((item, index) => (
          <div className="form-control-row" key={'onlineTemplate' + index}>
            <div className="form-control">
              <Input value={item.company_name} type="text" disabled={true} />
            </div>
            {item.updated_by !== 0 && (
              <>
                <div className="form-control">
                  <div className="data">
                    Questionaire Version :{' '}
                    {dateMonDayYearTime(item.questionnaire_version)}
                  </div>

                  <div className="data">
                    Requested date :{' '}
                    {item.is_send_mail
                      ? dateMonDayYearTime(item.requested_date)
                      : '-'}
                  </div>
                </div>
                <div className="form-control">
                  <div className="data">
                    Response date : {dateMonDayYearTime(item.response_date)}
                  </div>

                  <div className="data">By : {item.updated_by_string}</div>
                </div>
              </>
            )}
            <div className="form-control">
              {item.updated_by !== 0 && (
                <Button
                  className="theme-blue btn-comprehensive-score"
                  onClick={() => {
                    // this.props.history.push(
                    //   ROUTE_PATH.SUPPLIER_ONLINE_TEMPLATE_MANAGEMENT.LINK,
                    //   {
                    //     id: item.template_id,
                    //     supplierId: item.supplier_id,
                    //     display: true,
                    //   }
                    // )
                    window.open(
                      '/supplier-online-form-management/' +
                        item.template_id +
                        '/' +
                        item.supplier_id +
                        '/display',
                      '_blank'
                    )
                  }}
                >
                  Display
                </Button>
              )}

              <Button
                className="theme-blue btn-comprehensive-score"
                onClick={() => {
                  this.props.history.push(
                    ROUTE_PATH.SUPPLIER_ONLINE_TEMPLATE_MANAGEMENT.LINK,
                    { id: item.template_id, supplierId: userId }
                  )
                }}
              >
                Update
              </Button>
            </div>
          </div>
        ))}
      </div>
    )
  }

  renderLoadingDownload = index => {
    const { loadingDownloadFile } = this.state
    console.log('loading', loadingDownloadFile)
    return (
      loadingDownloadFile.length > 0 &&
      loadingDownloadFile.map((e, k) => {
        if (e.id_file === index) {
          console.log('loading true id', e)
          return (
            <Loaders
              load={true}
              key={k}
              style={{
                marginLeft: '-35px',
                position: 'relative',
                right: '-75px',
              }}
            />
          )
        }
      })
    )
  }

  render() {
    const {
      optionsCountry,
      modals,
      optionBusinessType,
      serviceState,
      infoCategory,
      isEditPageState,
      businessSubCategories,
      businessCategories,
      supplierCategory,
      supplierNation,
    } = this.state
    return (
      <React.Fragment>
        <CompanyProfileSupplierFormStyle>
          {/* PAGE TITLE
        -----------------------------------------------------
        -----------------------------------------------------
        */}
          <Section className="page-topbar">
            <Section className="page-header">
              <Section className="page-icon">
                <Image
                  id="page_icon_buyer_management"
                  src={ICONS['icon-company-white.svg']}
                  alt="page icon"
                />
              </Section>

              <Section className="title-and-breadcrumb">
                <Section id="page_title_buyer_management" className="title">
                  Company Profile
                </Section>

                <Section
                  id="page_breadcrumb_buyer_management"
                  className="breadcrumbs"
                >
                  <Button
                    className="breadcrumb"
                    onClick={() => {
                      this.props.history.push(ROUTE_PATH.HOME.LINK)
                    }}
                  >
                    <span>{STRING.HOME}</span>
                  </Button>

                  <Button className="breadcrumb current">
                    <span>Company Profile</span>
                  </Button>
                </Section>
              </Section>
            </Section>
          </Section>

          {/* PAGE CONTENT
        -----------------------------------------------------
        -----------------------------------------------------
        */}
          <Formik
            enableReinitialize
            initialValues={this.state.formInit}
            validationSchema={this.validateMySupplierCompanySchema}
            validateOnChange={true}
            validateOnBlur={false}
            onSubmit={(values, formiksAction) => {
              this.saveMySupplierCompany(values)
            }}
          >
            {props => {
              const {
                values,
                handleChange,
                errors,
                submitForm,
                setFieldValue,
                handleBlur,
              } = props

              return (
                <Form>
                  <Section className="main-content">
                    <Section className="content-body">
                      <Section className="form-wrapper">
                        <Section className="form-group-title">Details</Section>

                        <Section className="form-group">
                          <label>Tax ID</label>

                          <Section className="form-group-control">
                            <Section className="form-group-inner-wrapper">
                              <Input
                                value={values.tax_id}
                                type="text"
                                disabled={true}
                              />
                            </Section>

                            <Section className="message">error</Section>
                          </Section>
                        </Section>

                        <Section className="form-group">
                          <label>Company Name</label>

                          <Section className="form-group-control">
                            <Section className="form-group-inner-wrapper">
                              <Input
                                type="text"
                                value={values.company_name}
                                disabled={true}
                              />
                            </Section>

                            <Section className="message"></Section>
                          </Section>
                        </Section>

                        {this.state.formInit.company_type != 'Individual' ? (
                          <Section className="form-group">
                            <label>Branch</label>

                            <Section className="form-group-control">
                              <Section className="form-group-inner-wrapper">
                                <Input
                                  type="text"
                                  name="branch"
                                  value={values.branch}
                                  disabled={true}
                                />
                              </Section>

                              <Section className="message"></Section>
                            </Section>
                          </Section>
                        ) : (
                          ''
                        )}

                        {this.state.formInit.company_type != 'Individual' ? (
                          <Section className="form-group">
                            <label>Year Established</label>

                            <Section className="form-group-control">
                              <Section className="form-group-inner-wrapper">
                                {supplierNation === 'domestic' ? (
                                  <DatePickerInput
                                    selected={
                                      values.year_established
                                        ? new Date().setFullYear(
                                            values.year_established
                                          )
                                        : new Date()
                                    }
                                    name="year_established"
                                    showYearPicker
                                    dateFormat="yyyy"
                                    yearItemNumber={6}
                                    disabled={true}
                                  />
                                ) : (
                                  <DatePickerInput
                                    selected={
                                      values.year_established
                                        ? new Date().setFullYear(
                                            values.year_established
                                          )
                                        : new Date()
                                    }
                                    minDate={new Date('01-01-1000')}
                                    maxDate={new Date()}
                                    onChange={date => {
                                      // values.year_established = new Date(date)
                                      //   .getFullYear()
                                      //   .toString()
                                      const year = new Date(date)
                                        .getFullYear()
                                        .toString()
                                      setFieldValue('year_established', year)
                                      // this.setState({
                                      //   supplierInfo,
                                      // })
                                    }}
                                    name="year_established"
                                    showYearPicker
                                    dateFormat="yyyy"
                                    yearItemNumber={6}
                                    disabled={isEditPageState ? true : false}
                                  />
                                )}
                              </Section>

                              <Section className="message"></Section>
                            </Section>
                          </Section>
                        ) : (
                          ''
                        )}

                        {this.state.formInit.company_type != 'Individual' ? (
                          <Section
                            className={`form-group ${
                              errors.regis_capital && 'is-error'
                            }`}
                          >
                            <label>Registered Capital</label>

                            <Section className="form-group-control">
                              <Section className="form-group-inner-wrapper">
                                {/* <Input
                                  type="text"
                                  name="regis_capital"
                                  // value={props.values.regisCapital}
                                  value={strWithCommas(values.regis_capital)}
                                  disabled={isEditPageState}
                                  // onChange={handleChange('regis_capital')}
                                  onBlur={handleBlur('regis_capital')}
                                  onChange={e => {
                                    let numberCommas = ''
                                    numberCommas = numberRemoveCommas(
                                      e.target.value
                                    )
                                    const maxValue = '100000000000'
                                    if (
                                      numberCommas.length <= maxValue.length
                                    ) {
                                      numberCommas = e.target.value
                                    } else {
                                      numberCommas = maxValue
                                    }
                                    setFieldValue('regis_capital', numberCommas)
                                  }}
                                /> */}
                                {supplierNation === 'domestic' ? (
                                  <Input
                                    type="text"
                                    name="regis_capital"
                                    // value={props.values.regisCapital}
                                    value={
                                      Number(
                                        values.regis_capital
                                      ).toLocaleString() + ' THB'
                                    }
                                    disabled={true}
                                  />
                                ) : (
                                  <React.Fragment>
                                    <Input
                                      type="text"
                                      className="regis_capital"
                                      name="regis_capital"
                                      // value={props.values.regisCapital}
                                      value={strWithCommas(
                                        values.regis_capital
                                      )}
                                      disabled={isEditPageState}
                                      // onChange={handleChange('regis_capital')}
                                      onBlur={handleBlur('regis_capital')}
                                      onChange={e => {
                                        let numberCommas = ''
                                        numberCommas = numberRemoveCommas(
                                          e.target.value
                                        )
                                        const maxValue = '100000000000'
                                        if (
                                          numberCommas.length <= maxValue.length
                                        ) {
                                          numberCommas = e.target.value
                                        } else {
                                          numberCommas = maxValue
                                        }
                                        setFieldValue(
                                          'regis_capital',
                                          numberCommas
                                        )
                                      }}
                                    />
                                    <SelectBox
                                      id="active_status_currency"
                                      className="select-currency"
                                      name="currency"
                                      value={{
                                        value: values.currency.id,
                                        label: values.currency.name,
                                      }}
                                      onChange={val => {
                                        setFieldValue('currency', {
                                          id: val.id,
                                          name: val.label,
                                        })
                                      }}
                                      options={this.state.currencyOption}
                                      defaultValue={
                                        this.state.currencyOption[0]
                                      }
                                      isDisabled={isEditPageState}
                                      isSearchable={false}
                                      disabled={
                                        isEditPageState
                                          ? isEditPageState
                                          : supplierNation !== 'domestic'
                                          ? true
                                          : false
                                      }
                                    />
                                  </React.Fragment>
                                )}
                              </Section>

                              <Section className="message">
                                {errors.regis_capital}
                              </Section>
                            </Section>
                          </Section>
                        ) : (
                          ''
                        )}

                        <Section
                          className={`form-group aa ${
                            errors.regis_address && 'is-error'
                          }`}
                        >
                          <label className="registered-address">
                            Registered Address
                          </label>

                          <Section className="form-group-control">
                            <Section className="form-group-inner-wrapper">
                              {/* {values.contact_country === 'Thailand' ? (
                                <InputTextarea
                                  name="regis_address"
                                  disabled={true}
                                  value={values.regis_address}
                                  onChange={handleChange('regis_address')}
                                />
                              ) : (
                                <InputTextarea
                                  name="regis_address"
                                  disabled={isEditPageState}
                                  value={values.regis_address}
                                  onChange={handleChange('regis_address')}
                                />
                              )} */}
                              <InputTextarea
                                name="regis_address"
                                disabled={isEditPageState}
                                value={values.regis_address}
                                onChange={handleChange('regis_address')}
                              />
                            </Section>

                            <Section className="message">
                              {errors.regis_address}
                            </Section>
                          </Section>
                        </Section>

                        <Section
                          className={`form-group ${
                            errors.regis_country && 'is-error'
                          }`}
                        >
                          <label className="country">Country</label>

                          <Section className="form-group-control">
                            <Section className="form-group-inner-wrapper">
                              <SelectBox
                                name="regis_country"
                                defaultValue={optionsCountry[0]}
                                options={optionsCountry}
                                isSearchable={false}
                                isClearable={false}
                                isDisabled={true}
                                value={values.regis_country}
                              />
                            </Section>

                            <Section className="message">
                              {errors.regis_country}
                            </Section>
                          </Section>
                        </Section>

                        <Section
                          className={`form-group ${
                            errors.contact_address && 'is-error'
                          }`}
                        >
                          <label className="contact-address">
                            Contact Address
                          </label>

                          <Section className="form-group-control">
                            <Section className="form-group-inner-wrapper">
                              <InputTextarea
                                name="contact_address"
                                disabled={isEditPageState}
                                value={values.contact_address}
                                onChange={handleChange('contact_address')}
                                onBlur={handleBlur('contact_address')}
                              />
                            </Section>

                            <Section className="message">
                              {errors.contact_address}
                            </Section>
                          </Section>
                        </Section>

                        <Section className="form-group">
                          <label className="country">Country</label>
                          <Section className="form-group-control">
                            <Section className="form-group-inner-wrapper">
                              <SelectBox
                                name="contact_country"
                                defaultValue={optionsCountry[0]}
                                options={optionsCountry}
                                value={values.contact_country}
                                isSearchable={false}
                                isClearable={false}
                                isDisabled={isEditPageState}
                                onChange={val => {
                                  setFieldValue('contact_country', val)
                                  //this.onSelectCountry(val, 'contact_country')
                                }}
                                // value={supplierInfo.regis_country}
                              />
                            </Section>

                            <Section className="message"></Section>
                          </Section>
                        </Section>

                        <Section
                          className={`form-group ${errors.phone && 'is-error'}`}
                        >
                          <label className="phone">Phone</label>

                          <Section className="form-group-control">
                            <Section className="form-group-inner-wrapper">
                              <Input
                                name="phone"
                                type="text"
                                value={values.phone}
                                disabled={isEditPageState}
                                onChange={handleChange('phone')}
                                onBlur={handleBlur('phone')}
                              />
                            </Section>

                            <Section className="message">
                              {errors.phone}
                            </Section>
                          </Section>
                        </Section>

                        <Section className="form-group">
                          <label className="fax">
                            Fax <br /> (Optional)
                          </label>

                          <Section className="form-group-control">
                            <Section className="form-group-inner-wrapper">
                              <Input
                                name="fax"
                                type="text"
                                value={values.fax}
                                disabled={isEditPageState}
                                onChange={handleChange('fax')}
                                onBlur={handleBlur('fax')}
                              />
                            </Section>

                            <Section className="message"></Section>
                          </Section>
                        </Section>

                        <Section
                          className={`form-group ${errors.email && 'is-error'}`}
                        >
                          <label className="email">Email</label>

                          <Section className="form-group-control">
                            <Section className="form-group-inner-wrapper">
                              <Input
                                name="email"
                                type="text"
                                value={values.email}
                                disabled={isEditPageState}
                                onChange={handleChange('email')}
                                onBlur={handleBlur('email')}
                              />
                            </Section>

                            <Section className="message">
                              {errors.email}
                            </Section>
                          </Section>
                        </Section>

                        <Section className="form-group">
                          <label className="website">
                            Website <br /> (Optional)
                          </label>

                          <Section className="form-group-control">
                            <Section className="form-group-inner-wrapper">
                              <Input
                                name="website"
                                type="text"
                                value={values.website}
                                disabled={isEditPageState}
                                onChange={handleChange('website')}
                                onBlur={handleBlur('website')}
                              />
                            </Section>

                            <Section className="message"></Section>
                          </Section>
                        </Section>

                        <Section className="form-group">
                          <label className="tooltip-upload">
                            Attachment (Optional)
                            <Section className="link tooltip-attachment">
                              <Image
                                src={ICONS['icon-help.svg']}
                                alt="help"
                                tootipValue={`(*File type must be jpg, gif, png, bmp, tif, tiff, pdf, doc, docx, \n xls, xlsx, ppt, pptx, txt and Maximum File Size 50 Mb)`}
                                useTootipFor="FileType"
                                useTootip={true}
                              />
                            </Section>
                          </label>
                          <Section className="form-group-control">
                            {!isEditPageState ? (
                              <Section className="form-group-inner-wrapper">
                                <AttachedFile
                                  maxFileSizeMb={50}
                                  onSelect={(file, e, cb) => {
                                    if (file) {
                                      this.setInputArrayUploadFile(file)
                                      values.file_supplier_discovery.push({
                                        name: file.name,
                                        supplier_company_id:
                                          values.supplier_company_id,
                                        files: file,
                                      })

                                      this.setState(
                                        {
                                          attachmentFile:
                                            values.file_supplier_discovery,
                                        },
                                        cb
                                      )
                                    }
                                  }}
                                />
                              </Section>
                            ) : null}
                            {/* Should show when selected file */}
                            {values.file_supplier_discovery &&
                              values.file_supplier_discovery.map(
                                (fileValue, i) => {
                                  return (
                                    <>
                                      <React.Fragment key={i}>
                                        <Section
                                          className="attached-file-list"
                                          style={{ cursor: 'pointer' }}
                                        >
                                          <a
                                            className="file-link"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                          >
                                            <span
                                              className="file-name"
                                              onClick={e => {
                                                this.downloadAttachment(
                                                  fileValue,
                                                  i
                                                )
                                              }}
                                            >
                                              {fileValue.name}
                                            </span>
                                            {!isEditPageState ? (
                                              <Button
                                                className="link"
                                                onClick={() => {
                                                  values.file_supplier_discovery.splice(
                                                    i,
                                                    1
                                                  ),
                                                    this.forceUpdate()
                                                }}
                                              >
                                                <Image
                                                  className="delete-circle-icon delete_company_profile"
                                                  src={
                                                    ICONS[
                                                      'icon-delete-circle-red.svg'
                                                    ]
                                                  }
                                                  alt="delete circle"
                                                />
                                              </Button>
                                            ) : null}
                                          </a>
                                          {this.renderLoadingDownload(i)}
                                        </Section>
                                      </React.Fragment>
                                    </>
                                  )
                                }
                              )}
                          </Section>
                        </Section>

                        <Section className="form-group-header">Service</Section>
                        <Section
                          className={`form-group ${
                            errors.business_type && 'is-error'
                          }`}
                        >
                          <label className="business-type">
                            Business Type:
                          </label>

                          <Section className="form-group-control">
                            <Section className="form-group-inner-wrapper checkbox">
                              {!!optionBusinessType &&
                                optionBusinessType.map((e, i) => (
                                  <Checkbox
                                    name="business_type"
                                    key={i}
                                    id={i}
                                    value={e.value}
                                    checked={e.checked}
                                    // onChange={e =>
                                    //   this.onChangeBusinessType(e, i)
                                    // }
                                    onChange={e => {
                                      this.onChangeBusinessType(
                                        setFieldValue,
                                        e,
                                        i
                                      )
                                    }}
                                    isDisabled={isEditPageState}
                                  >
                                    {e.value}
                                  </Checkbox>
                                ))}
                            </Section>

                            <Section className="message">
                              {errors.business_type}
                            </Section>
                          </Section>
                        </Section>
                        <Section
                          className={`form-group ${
                            errors.my_supplier_company_service_category &&
                            'is-error'
                          }`}
                        >
                          <label className="service-category">
                            Service Category:
                          </label>

                          <Section className="form-group-control">
                            <Section className="form-group-inner-wrapper">
                              {!isEditPageState ? (
                                <Section>
                                  <Button
                                    className="theme-blue add"
                                    onClick={() => this.onClickAdd()}
                                  >
                                    {/* <Image
                                      src={ICONS['icon-add-circular.svg']}
                                      alt="add icon"
                                    /> */}
                                    Add New
                                  </Button>
                                </Section>
                              ) : null}

                              <Table className="service-category-table">
                                <Table.THEAD>
                                  <Table.TR className="header">
                                    <Table.TD className="business-group">
                                      Business Group
                                    </Table.TD>

                                    <Table.TD className="service-product">
                                      Service & Product
                                    </Table.TD>
                                    <Table.TD className="service-btn"></Table.TD>
                                  </Table.TR>
                                </Table.THEAD>

                                {supplierCategory &&
                                  supplierCategory.map((e, i) => (
                                    <React.Fragment key={i}>
                                      <Table.TBODY>
                                        <Table.TR>
                                          <Table.TD
                                            name="my_supplier_company_service_category"
                                            className="business-group"
                                          >
                                            {e.category_name}
                                          </Table.TD>

                                          <Table.TD className="service-product">
                                            {e.sub_category.map((j, index) => {
                                              return (
                                                <React.Fragment key={index}>
                                                  {j.sub_category_name}
                                                  <br />
                                                </React.Fragment>
                                              )
                                            })}
                                          </Table.TD>
                                          <Table.TD>
                                            {serviceState ? (
                                              <Section>
                                                <Button
                                                  className="theme-blue edit"
                                                  onClick={() => {
                                                    this.onEditCategory(e, i)
                                                  }}
                                                >
                                                  Edit
                                                </Button>
                                                <Button
                                                  className="theme-red delete"
                                                  onClick={() => {
                                                    this.onDeleteCategory(e, i)
                                                  }}
                                                >
                                                  Delete
                                                </Button>
                                              </Section>
                                            ) : (
                                              ''
                                            )}
                                          </Table.TD>
                                        </Table.TR>
                                      </Table.TBODY>
                                    </React.Fragment>
                                  ))}
                              </Table>
                            </Section>

                            <Section className="message">
                              {errors.my_supplier_company_service_category}
                            </Section>
                          </Section>
                        </Section>
                        {/* <Section className="form-group">
                          <label></label>
                          <Section className="form-group-control">
                            <Section className="form-group-inner-wrapper checkbox">
                              <Checkbox
                                id="supplier_need_to_join"
                                value="want-to-join"
                                name="joinMainSupplier"
                                checked={joinMainSupplier}
                                // onChange={e => this.onJoinMainSupplier(e)}
                                // onChange={props.handleChange(
                                //   'joinMainSupplier'
                                // )}
                                // onBlur={props.handleBlur('joinMainSupplier')}
                              >
                                I want to join TSPACE Supplier Directory for
                                business opportunity
                              </Checkbox>
                            </Section>

                            <Section className="message"></Section>
                          </Section>
                        </Section> */}

                        <Section className="form-group update-comprehensive">
                          <label className="update-online">
                            Update Online Comprehensive :
                          </label>

                          {this.state.onlineTemplates.length > 0 &&
                            this.renderOnlineComprehensive()}
                        </Section>
                      </Section>

                      <Section className="form-actions">
                        {this.state.editState && (
                          <Button
                            onClick={() => this.editForm()}
                            className="theme-blue"
                          >
                            Edit
                          </Button>
                        )}
                        {this.state.cancelState && (
                          <Button
                            onClick={() => {
                              this.cancelForm(props)
                            }}
                            className="theme-border-gray"
                          >
                            Cancel
                          </Button>
                        )}
                        {this.state.saveState && (
                          <Button
                            // onClick={() => {
                            //   this.saveMySupplierCompany(values)
                            // }}
                            onClick={submitForm}
                            className="theme-green"
                          >
                            Save
                          </Button>
                        )}
                      </Section>
                    </Section>
                  </Section>
                </Form>
              )
            }}
          </Formik>
        </CompanyProfileSupplierFormStyle>

        {/*Modal Edit*/}
        <Modal
          id="edit"
          className="supplier-registration buyer edit theme-blue"
          isOpen={
            modals
              .filter(modal => {
                return modal.name === 'edit'
              })
              .map(obj => obj.isOpen)[0]
          }
        >
          <Modal.Header>Edit Service Category</Modal.Header>

          <Modal.Body>
            <Section className="form-wrapper">
              <Section className="form-group">
                <label>Business Group</label>

                <Section className="form-group-control">
                  <Section className="form-group-inner-wrapper">
                    <Input
                      type="text"
                      name="energy"
                      value={infoCategory.category_name || null}
                      disabled
                    />
                  </Section>
                </Section>
              </Section>

              <Section className="form-group">
                <label className="label">Service & Product</label>

                <Section className="form-group-control">
                  <Section className="checkbox-list flex-wrap">
                    {!!businessSubCategories &&
                      businessSubCategories.map((e, i) => (
                        <Checkbox
                          key={i}
                          id={e.value}
                          value={e.value}
                          checked={e.checked}
                          onChange={e => this.onChangeSubCategory(e, i)}
                        >
                          {e.value}
                        </Checkbox>
                      ))}
                  </Section>
                </Section>
              </Section>
            </Section>
          </Modal.Body>

          <Modal.Footer>
            <Button
              id=""
              className="theme-gray close"
              onClick={() => {
                this.onClickClose()
              }}
            >
              Cancel
            </Button>

            <Button
              id=""
              className="theme-green save"
              onClick={() => {
                this.validateCheckbox() ? {} : this.onClickConfirmEdit()
              }}
              disabled={this.validateCheckbox()}
            >
              Confirm
            </Button>
          </Modal.Footer>
        </Modal>

        {/*Modal Delete*/}
        <Modal
          id="delete"
          className="theme-blue"
          isOpen={
            modals
              .filter(modal => {
                return modal.name === 'delete'
              })
              .map(obj => obj.isOpen)[0]
          }
          modalWidth="575px"
        >
          <Modal.Header>Delete</Modal.Header>

          <Modal.Body>
            <p className="default text-center">
              Are you sure to delete? <br />
              {infoCategory.category_name || null}
            </p>
          </Modal.Body>

          <Modal.Footer>
            <Button
              id=""
              className="theme-gray"
              onClick={() => {
                this.toggleModal('delete')
              }}
            >
              Cancel
            </Button>

            <Button
              id=""
              className="theme-green"
              onClick={() => {
                this.onClickConfirmDelete()
              }}
            >
              Confirm
            </Button>
          </Modal.Footer>
        </Modal>

        {/*Modal Add New*/}
        <Modal
          id="add"
          className="supplier-registration buyer add theme-blue"
          isOpen={
            modals
              .filter(modal => {
                return modal.name === 'add'
              })
              .map(obj => obj.isOpen)[0]
          }
        >
          <Modal.Header>Add Service Category</Modal.Header>

          <Modal.Body>
            <Section className="form-wrapper">
              <Section className="form-group select-template">
                <label>Business Group</label>

                <Section className="form-group-control">
                  <Section className="form-group-inner-wrapper">
                    <SelectBox
                      placeholder="Select Business Group"
                      className="select-template"
                      value={infoCategory.category_option || null}
                      options={businessCategories}
                      onChange={e => {
                        this.onChangeBusinessGroup(e)
                      }}
                    />
                  </Section>
                </Section>
              </Section>
              {infoCategory.category_option && (
                <Section className="form-group">
                  <label className="label">Service & Product</label>

                  <Section className="form-group-control">
                    <Section className="form-group-inner-wrapper checkbox">
                      {!!businessSubCategories &&
                        businessSubCategories.map((e, i) => (
                          <Checkbox
                            key={i}
                            id={e.value}
                            value={e.value}
                            checked={e.checked}
                            onChange={e => this.onChangeSubCategory(e, i)}
                          >
                            {e.value}
                          </Checkbox>
                        ))}
                    </Section>
                  </Section>
                </Section>
              )}
            </Section>
          </Modal.Body>

          <Modal.Footer>
            <Button
              id=""
              className="theme-gray close"
              onClick={() => {
                this.onClickClose()
              }}
            >
              Cancel
            </Button>

            <Button
              id=""
              className="theme-green save"
              onClick={() => {
                this.validateCheckbox() ? {} : this.onClickConfirm()
              }}
              disabled={this.validateCheckbox()}
            >
              Confirm
            </Button>
          </Modal.Footer>
        </Modal>
      </React.Fragment>
    )
  }
}
